import { render, staticRenderFns } from "./IpoPortfolioDetails.vue?vue&type=template&id=6a45ca93&scoped=true"
import script from "./IpoPortfolioDetails.vue?vue&type=script&lang=js"
export * from "./IpoPortfolioDetails.vue?vue&type=script&lang=js"
import style0 from "./IpoPortfolioDetails.vue?vue&type=style&index=0&id=6a45ca93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a45ca93",
  null
  
)

export default component.exports